export interface DoctorVisitsServiceSchemaInput {
  canonicalUrl: string;
  name: string;
  description: string;
  serviceType: string;
}

export function buildDoctorVisitsServiceSchema({
  canonicalUrl,
  name,
  description,
  serviceType,
}: DoctorVisitsServiceSchemaInput): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name,
    description,
    serviceType,
    url: canonicalUrl,
    provider: {
      "@type": "Organization",
      name: "Docio Health",
      url: "https://dociohealth.com",
    },
    audience: {
      "@type": "PeopleAudience",
      audienceType: "Patients and people arranging care for a patient",
    },
  };
}
